import type { LedgerEntry } from '../../core/models/types';

export function isSportingAward(category?: string): boolean {
  return ['MATCHDAY_AWARD', 'PRIZE_MONEY'].includes((category || '').trim().toUpperCase());
}

const madridDay = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit',
});

export function groupDailyAwards(entries: LedgerEntry[]): LedgerEntry[] {
  const groups = new Map<string, LedgerEntry>();
  const result: LedgerEntry[] = [];
  // Entries arrive newest first; retain the latest entry's balance and position.
  for (const entry of entries) {
    const date = new Date(entry.timestamp);
    if (!isSportingAward(entry.category) || !Number.isFinite(date.getTime())) {
      result.push(entry);
      continue;
    }
    const day = madridDay.format(date);
    const key = `${day}:${entry.direction || entry.type}`;
    const group = groups.get(key);
    if (group) {
      group.amount = Math.round((group.amount + entry.amount) * 100_000_000) / 100_000_000;
    } else {
      const grouped = { ...entry, id: `sporting-awards:${key}`, concept: 'Premios deportivos',
        category: 'MATCHDAY_AWARD', sourceType: 'MATCHDAY_AWARD', sourceReference: day };
      groups.set(key, grouped);
      result.push(grouped);
    }
  }
  return result;
}
